<template>
  <v-container class="page-container p-3">
    <ExpenseConfigDetailContainer />
  </v-container>
</template>

<script>
import ExpenseConfigDetailContainer from "@/components/Container/ExpenseConfigDetailContainer.vue"
export default {
  components: { ExpenseConfigDetailContainer },
}
</script>
